import { render, staticRenderFns } from "./_GoodsCategory.vue?vue&type=template&id=79cba836&"
import script from "./_GoodsCategory.vue?vue&type=script&lang=js&"
export * from "./_GoodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./_GoodsCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports